const RISK_STATUS = {
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low'
};

export {
    RISK_STATUS
};
